import { CircularProgress } from "@material-ui/core";
import useStyles from "./styles";

const CustomLoader = ({ text, type }) => {
  const classes = useStyles();

  return (
    <div className={classes.load}>
      <CircularProgress color="secondary" />
    </div>
  );
};

export default CustomLoader;
